import { render, staticRenderFns } from "./studiestoExplore.vue?vue&type=template&id=e57b5ace&scoped=true&"
import script from "./studiestoExplore.vue?vue&type=script&lang=js&"
export * from "./studiestoExplore.vue?vue&type=script&lang=js&"
import style0 from "./studiestoExplore.vue?vue&type=style&index=0&id=e57b5ace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b5ace",
  null
  
)

export default component.exports